import {
  AutomationFieldRenderType,
  AutomationActionInputField,
} from 'api/automation-builder/types';
import { ObjectType } from 'api/pushes';
import {
  FieldDataType,
  FieldTypes,
} from 'components/organisms/module-settings/fields/types';
import { getRandomColor } from 'utils/get-random-color';

export const WEBHOOK_FIELDS = ({
  isBodyRequired,
}: {
  isBodyRequired?: boolean;
}): AutomationActionInputField[] => [
  {
    fieldName: 'name',
    fieldType: FieldTypes.SingleSelect,
    fieldDataType: FieldDataType.Text,
    fieldLabel: 'Name',
    required: true,
    sticky: true,
    dynamic: false,
    triggersDynamic: false,
    placeholderValue: 'fromFieldLabel',
    placeholderLabel: 'fromFieldLabel',
    customField: true,
    fieldColumnName: 'Defualt',
    fieldGroup: '',
    fieldId: -1,
    isEditable: true,
    sourceType: ObjectType.Project,
    metaData: {},
    objectType: ObjectType.Project,
    parentFieldName: '',
    private: false,
  },
  {
    fieldName: 'description',
    fieldType: FieldTypes.SingleSelect,
    fieldDataType: FieldDataType.MultiLineText,
    fieldLabel: 'Description',
    required: false,
    sticky: true,
    dynamic: false,
    triggersDynamic: false,
    placeholderValue: 'fromFieldLabel',
    placeholderLabel: 'fromFieldLabel',
    customField: true,
    fieldColumnName: 'Defualt',
    fieldGroup: '',
    fieldId: -1,
    isEditable: true,
    sourceType: ObjectType.Project,
    metaData: {},
    objectType: ObjectType.Project,
    parentFieldName: '',
    private: false,
  },
  {
    fieldName: 'method',
    fieldType: FieldTypes.SingleSelect,
    fieldDataType: FieldDataType.Text,
    fieldLabel: 'Method',
    required: true,
    sticky: true,
    dynamic: false,
    triggersDynamic: false,
    placeholderValue: 'fromFieldLabel',
    placeholderLabel: 'fromFieldLabel',
    customField: true,
    fieldColumnName: 'Defualt',
    fieldGroup: '',
    fieldId: -1,
    isEditable: true,
    sourceType: ObjectType.Project,
    metaData: {
      options: [
        {
          color: getRandomColor('GET'),
          label: 'GET',
          value: 'GET',
        },
        {
          color: getRandomColor('POST'),
          label: 'POST',
          value: 'POST',
        },
        {
          color: getRandomColor('PUT'),
          label: 'PUT',
          value: 'PUT',
        },
        {
          color: getRandomColor('DELETE'),
          label: 'DELETE',
          value: 'DELETE',
        },
      ],
    },
    objectType: ObjectType.Project,
    parentFieldName: '',
    private: false,
  },
  {
    fieldName: 'urlToNotify',
    fieldType: FieldTypes.SingleSelect,
    fieldDataType: FieldDataType.Text,
    fieldLabel: 'Url',
    required: true,
    sticky: true,
    dynamic: true,
    triggersDynamic: true,
    placeholderValue: 'fromFieldLabel',
    placeholderLabel: 'fromFieldLabel',
    customField: true,
    fieldColumnName: 'Defualt',
    fieldGroup: '',
    fieldId: -1,
    isEditable: true,
    sourceType: ObjectType.Project,
    metaData: {},
    objectType: ObjectType.Project,
    parentFieldName: '',
    private: false,
  },
  {
    fieldName: 'headers',
    renderAs: AutomationFieldRenderType.KeyValuePair,
    fieldType: FieldTypes.SingleSelect,
    fieldDataType: FieldDataType.MultiLineText,
    fieldLabel: '',
    required: false,
    sticky: true,
    dynamic: false,
    triggersDynamic: false,
    placeholderValue: 'fromFieldLabel',
    placeholderLabel: 'fromFieldLabel',
    customField: true,
    fieldColumnName: 'Defualt',
    fieldGroup: '',
    fieldId: -1,
    isEditable: true,
    sourceType: ObjectType.Project,
    metaData: {},
    objectType: ObjectType.Project,
    parentFieldName: '',
    private: false,
  },
  {
    fieldName: 'queryParams',
    renderAs: AutomationFieldRenderType.KeyValuePair,
    fieldType: FieldTypes.SingleSelect,
    fieldDataType: FieldDataType.MultiLineText,
    fieldLabel: '',
    required: false,
    sticky: true,
    dynamic: false,
    triggersDynamic: false,
    placeholderValue: 'fromFieldLabel',
    placeholderLabel: 'fromFieldLabel',
    customField: true,
    fieldColumnName: 'Defualt',
    fieldGroup: '',
    fieldId: -1,
    isEditable: true,
    sourceType: ObjectType.Project,
    metaData: {},
    objectType: ObjectType.Project,
    parentFieldName: '',
    private: false,
  },
  {
    fieldName: 'body',
    fieldType: FieldTypes.SingleSelect,
    fieldDataType: FieldDataType.MultiLineText,
    fieldLabel: 'Body',
    required: isBodyRequired,
    sticky: true,
    dynamic: false,
    triggersDynamic: false,
    placeholderValue: 'fromFieldLabel',
    placeholderLabel: 'fromFieldLabel',
    customField: true,
    fieldColumnName: 'Defualt',
    fieldGroup: '',
    fieldId: -1,
    isEditable: true,
    sourceType: ObjectType.Project,
    metaData: {},
    objectType: ObjectType.Project,
    parentFieldName: '',
    private: false,
    renderAs: AutomationFieldRenderType.JsonEditor,
  },
  {
    fieldName: 'previewUrl',
    fieldType: FieldTypes.SingleSelect,
    fieldDataType: FieldDataType.Text,
    fieldLabel: 'Preview URL',
    required: false,
    sticky: true,
    dynamic: false,
    triggersDynamic: false,
    placeholderValue: 'fromFieldLabel',
    placeholderLabel: 'fromFieldLabel',
    customField: true,
    fieldColumnName: 'Defualt',
    fieldGroup: '',
    fieldId: -1,
    isEditable: false,
    sourceType: ObjectType.Project,
    metaData: {},
    objectType: ObjectType.Project,
    parentFieldName: '',
    private: false,
  },
];

export const CONNECT_TO_SLACK_FIELD_NAME = 'connectToSlack';

export const CONNECT_TO_SLACK_FIELD: AutomationActionInputField = {
  fieldName: CONNECT_TO_SLACK_FIELD_NAME,
  fieldType: FieldTypes.SingleSelect,
  fieldDataType: FieldDataType.Text,
  fieldLabel: CONNECT_TO_SLACK_FIELD_NAME,
  required: false,
  sticky: true,
  dynamic: false,
  triggersDynamic: false,
  placeholderValue: CONNECT_TO_SLACK_FIELD_NAME,
  placeholderLabel: CONNECT_TO_SLACK_FIELD_NAME,
  customField: true,
  fieldColumnName: 'Defualt',
  fieldGroup: '',
  fieldId: -1,
  isEditable: false,
  sourceType: ObjectType.Project,
  metaData: {},
  objectType: ObjectType.Project,
  parentFieldName: '',
  private: false,
  renderAs: AutomationFieldRenderType.ConnectToSlack,
};

export const NO_WEBHOOKS_FOUND_FIELD_NAME = 'noWebhooksFound';

export const NO_WEBHOOKS_FOUND_FIELD: AutomationActionInputField = {
  fieldName: NO_WEBHOOKS_FOUND_FIELD_NAME,
  fieldType: FieldTypes.SingleSelect,
  fieldDataType: FieldDataType.Text,
  fieldLabel: NO_WEBHOOKS_FOUND_FIELD_NAME,
  required: false,
  sticky: true,
  dynamic: false,
  triggersDynamic: false,
  placeholderLabel: NO_WEBHOOKS_FOUND_FIELD_NAME,
  placeholderValue: NO_WEBHOOKS_FOUND_FIELD_NAME,
  customField: true,
  fieldColumnName: 'Default',
  fieldGroup: '',
  fieldId: -1,
  isEditable: false,
  sourceType: ObjectType.Project,
  metaData: {},
  objectType: ObjectType.Project,
  parentFieldName: '',
  private: false,
  renderAs: AutomationFieldRenderType.NoWebhooksFound,
};

export const DEFAULT_HTTP_PAYLOAD =
  '{"taskId":101,"taskName":"Train New Joinees","taskDescription":"<p>Train New Joinees</p>","privateTaskDescription":"<p>Are they good?</p>","type":"TASK","parentTask":12345,"subTasks":[],"dependentTasks":[],"project":{"projectName":"Reebok","projectId":1},"dueDate":"2021-06-08","startDate":"2021-06-03","commentThreadId":1,"createdBy":11,"createdAt":1621837025116,"attachments":[],"effort":5,"atRisk":true,"projectPhase":{"projectPhaseId":2,"projectPhaseName":"Design","tasks":[]},"source":{"sourceType":"DEFAULT"},"progress":30}';
export const URL_TO_NOTIFY = 'urlToNotify';
export const PLACEHOLDER_DEEP_VARIABLE_SUFFIX = '_DEEP_';
